import React, { useEffect, useRef, useState } from "react";
import styled from 'styled-components';
import {
    PaymentElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import StripeBadge from '../../assets/stripe-badge-transparent.png';
import { Circles } from "react-loader-spinner";
import { Bars } from "react-loader-spinner";



const CheckoutButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 13px;
  width: 399px;
  height: 44px;
  background: #FFFFFF;
`

export default function SaveCardForm() {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [ready, setReady] = useState(false);
    const url = window.location.href;
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        window.analytics.track('card_adding_started', {
            type: 'web',
        });

        if (!stripe || !elements) {return;}

        setIsLoading(true);

        const { error } = await stripe.confirmSetup({
            elements,
            confirmParams: {
            return_url: url,
            },
        });
        if (error.type === "card_error" ||
                error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("An unexpected error occured.");
        }

        window.analytics.track('card_added', {
            type: 'web',
            success: error
        });

        setIsLoading(false);
    };

    return (
	<>
	    <form id="payment-form" onSubmit={handleSubmit} style={{height:'100%'}}>
            <div style={{display:'flex', height:'100%', flexDirection: 'column'}}>
                <>
                    <PaymentElement
                        id="payment-element"
                        onReady={()=>{setReady(true)}}
                        />
                        {(!ready) && (
                            <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'100%'}}>
                                <Circles ariaLabel="loading-indicator" />
                            </div>
                        )}
		                {(ready) && (
		                    <CheckoutButton
                                style={{outine:'none',
                                    border: 'none',
                                    cursor: 'pointer'
                                }}
			                    disabled={isLoading || !stripe || !elements}
			                    id="submit">
			                        <span style={{color:'black'}} id="button-text">
			                            {isLoading ?
			                            <Bars
                                                        heigth="30" width="30"
                                                        color="grey"
                                                        ariaLabel="loading-indicator" /> : "Add Card"}
			                        </span>
		                    </CheckoutButton>
		                )}
                </>
		        {message && <div id="payment-message">{message}</div>}
            </div>
	    </form>
	</>
    );
}
